import PageRecord from "models/view-models/page-record";
import ServiceFactory from "utilities/services/service-factory";
import ServiceHookFactory from "utilities/services/service-hook-factory";

export interface SharedPagePathParams {
    pageGuid: string;
}

export interface SharedPageQueryParams {
    recipient?: string;
}

const endpoint: string = "shared/pages/:pageGuid";
const resourceType = PageRecord;

const SharedPageService = {
    get: ServiceFactory.get<
        PageRecord,
        SharedPagePathParams,
        SharedPageQueryParams
    >(resourceType, endpoint),
    useGet: ServiceHookFactory.useGet<
        PageRecord,
        SharedPagePathParams,
        SharedPageQueryParams
    >(resourceType, endpoint),
};

export default SharedPageService;
